import { useClient } from "~/stores/client";

export default defineNuxtPlugin(async ({ $pinia }) => {
    const client = useClient($pinia);

    if (!client.isAuthenticated) {
        await client.refreshToken();
    }
});
